// API client for Geographic Sales Intelligence.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/geographic-sales`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

// `progress` is set while the account's first sync is still running.
export class ReportUnavailableError extends Error {
  constructor(message, progress = null) {
    super(message);
    this.reportUnavailable = true;
    this.progress = progress;
  }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message, data.progress || null);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

// SF1–SF3. `grain` picks the level; `state` and `city` scope a drill so the
// results are that parent's children rather than a re-ranked country.
export const getRegions = (token, { start, end, grain, state, city } = {}) => {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  if (grain) params.set('grain', grain);
  if (state) params.set('state', state);
  if (city) params.set('city', city);
  const query = params.toString();
  return call(`${BASE}/regions${query ? `?${query}` : ''}`, {
    headers: authHeaders(token),
  });
};

// SF6. `by` picks the product grain (product type by default, ASIN on request);
// `grain` picks the geographic one; `state` narrows the rows already computed.
export const getProductIndex = (token, { start, end, grain, by, state } = {}) => {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  if (grain) params.set('grain', grain);
  if (by) params.set('by', by);
  if (state) params.set('state', state);
  const query = params.toString();
  return call(`${BASE}/product-index${query ? `?${query}` : ''}`, {
    headers: authHeaders(token),
  });
};

// SF4. Velocity measured against buyable days, and what unavailability cost.
export const getTrueDemand = (token, { start, end } = {}) => {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const query = params.toString();
  return call(`${BASE}/true-demand${query ? `?${query}` : ''}`, {
    headers: authHeaders(token),
  });
};
